import React from "react";

export default function SearchItem({slug, name, selected, onHover}) {
    return <a href={slug} onMouseEnter={onHover} className={`d-block line-height-3 mb-1 ${selected ? 'text-primary' : 'text-dark'}`}>{name}</a>
}